
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.676 37.014h-13.34a3.334 3.334 0 01-3.334-3.334V10.337a3.334 3.334 0 013.335-3.335h21.675a3.334 3.334 0 013.335 3.335V18.5","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.33 27.724c-3.827 0-7.08-1.969-8.33-4.724v.839c0 5.01 3.683 9.098 8.33 9.405v3.917l6.664-6.664-6.664-6.664v3.887","fill":"#F9B621"}}),_c('path',{attrs:{"d":"M33.33 27.724c-3.827 0-7.08-1.969-8.33-4.724v.839c0 5.01 3.683 9.098 8.33 9.405v3.917l6.664-6.664-6.664-6.664v3.887M14.671 14.672h15.007M14.671 21.341h6.67M14.671 29.01h5.003","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    